<template>
  <div class="flex-1"></div>
</template>

<script>
import { mapState } from 'vuex'
import emitter from '@/services/emitter.service'

// Visiting /login starts the same Auth0 login flow as the header's login
// button (see App.vue's handleAuth0Redirect, bound to the 'open-auth0' event).
// Auth0 redirects back to the site root, so this route is never re-entered
// after a successful login.
export default {
  name: 'LoginView',
  computed: {
    ...mapState('auth', ['authorized']),
  },
  mounted() {
    if (this.authorized) {
      this.$router.replace({ name: 'home' })
      return
    }

    emitter.emit('open-auth0')
  }
}
</script>
